import { helper } from '@ember/component/helper';

export default helper(function lastFourDigits([id]: [number | string | null]) {
  if (id == null) {
    return '';
  }
  return id.toString().slice(-4);
});
